import React, { FC } from 'react';
import { Outlet, useParams, useSearchParams } from 'react-router-dom';
import { MessagesSidePanel } from './components/MessagesSidePanel/MessagesSidePanel';
import './DashboardMessagesLayout.scss';

export const DashboardMessagesLayout: FC = () => {
  const { chatId, checkinId } = useParams();
  const [searchParams] = useSearchParams();
  const inquiryId = searchParams.get('inquiryId') || undefined;

  return (
    <div className="dashboard-messages-split-layout">
      {/* Desktop-only Side Panel */}
      <aside className="messages-side-panel-pane">
        <MessagesSidePanel
          activeChatId={chatId}
          activeCheckinId={checkinId}
          activeInquiryId={inquiryId}
        />
      </aside>

      {/* Main Content Area (Outlet renders ChatDetails, CheckinDetails, or Messages on mobile, or Placeholder on desktop) */}
      <main className="messages-main-pane">
        <Outlet />
      </main>
    </div>
  );
};
